module.exports = __webpack_public_path__ + "img/logo-iduam.d34cffcc.png";